export default __webpack_public_path__ + "assets/snow.ef3313da.svg";